import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../../locales/keys';
import { Grid, Typography } from '@material-ui/core';
import sanitizeHtml from 'sanitize-html';
import { getCurrencyDetails } from '../../../../utils/common';

const useStyles = makeStyles((theme) => ({
  termsAndConditionsDiscountDetails: {
    marginTop: '16px',
    marginLeft: '24px',
    marginRight: '24px',
    marginBottom: '0px',
    textAlign: 'center',
  },
  termsAndConditionsList: {
    listStyleType: 'square',
    listStylePosition: 'inside',
    marginLeft: '24px',
    marginRight: '24px',
    marginBottom: '0px',
    textAlign: 'left',
    padding: 0,
  },
  termsAndConditionsListItem: {
    fontSize: '11px',
    lineHeight: '16px',
    letterSpacing: '.5px',
    fontWeight: 400,
    color: '#D0D0D2',
  },
  termsAndConditionsCTA: {
    marginTop: '8px',
    fontSize: '11px',
    lineHeight: '16px',
    letterSpacing: '.5px',
    fontWeight: 600,
    color: '#D0D0D2',
    textAlign: 'center',
    textDecorationLine: 'underline',
    border: 'none',
  },
}));

const RetentionTermsAndConditions = (props) => {
  const { discountDetails, subscriptionProps } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const termsAndConditions = [
    t(LocaleKeys.retention.retentionTermsAndConditionsLine1),
    t(LocaleKeys.retention.retentionTermsAndConditionsLine2),
    t(LocaleKeys.retention.retentionTermsAndConditionsLine3),
    t(LocaleKeys.retention.retentionTermsAndConditionsLine4),
    t(LocaleKeys.retention.retentionTermsAndConditionsLine5),
    t(LocaleKeys.retention.retentionTermsAndConditionsLine6),
  ];

  const calculateDiscount = (fullPrice) => {
    var discountPrice;
    if (discountDetails?.DiscountType === 1) {
      discountPrice =
        fullPrice - (fullPrice / 100) * discountDetails?.DiscountAmount;
    } else {
      discountPrice = fullPrice - discountDetails?.DiscountAmount;
    }
    return Math.round(discountPrice * 100) / 100;
  };
  const fullPriceForDisplay = getCurrencyDetails(
    subscriptionProps?.pricingPlanChargeAmount,
    subscriptionProps?.pricingPlanCurrency,
  )?.priceWithCurrencySymbol;
  const discountPrice = calculateDiscount(
    subscriptionProps?.pricingPlanChargeAmount,
  );
  const discountPriceForDisplay = getCurrencyDetails(
    discountPrice,
    subscriptionProps?.pricingPlanCurrency,
  )?.priceWithCurrencySymbol;

  return (
    <>
      <Grid container direction="row" justifyContent="center" xm={0}>
        <Typography
          className={`${classes.termsAndConditionsDiscountDetails} ${classes.termsAndConditionsListItem}`}
          display="block"
        >
          {t(LocaleKeys.retention.termsAndConditionsLine1, {
            discountAmount: discountDetails?.DiscountAmount,
            discountPrice: discountPriceForDisplay,
            discountPeriod: discountDetails?.DiscountPeriod,
            discountUnit:
              discountDetails?.DiscountPeriod === 1
                ? t(LocaleKeys.retention.singleMonth)
                : t(LocaleKeys.retention.pluralMonth),
          })}
          <br />
          {t(LocaleKeys.retention.termsAndConditionsLine2, {
            fullPrice: fullPriceForDisplay,
          })}
          <br />
          {t(LocaleKeys.retention.termsAndConditionsLine3, {})}
          <br />
        </Typography>
      </Grid>
      <Grid container direction="row" justifyContent="center" xm={0}>
        <ul className={classes.termsAndConditionsList}>
          {termsAndConditions?.map((terms, index) => (
            <Typography
              className={classes.termsAndConditionsListItem}
              display="block"
              key={`retention-term-and-conditions-list-item-${index}`}
            >
              <li
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(terms, {
                    allowedClasses: {
                      a: ['retention-terms-and-conditions-cta'],
                    },
                  }),
                }}
              />
            </Typography>
          ))}
        </ul>
      </Grid>
    </>
  );
};

export default RetentionTermsAndConditions;
